export default {"src":"/_next/static/media/stressMotivationMobile.d94353b7.svg","height":233,"width":272,"blurWidth":0,"blurHeight":0};